import wishlist1 from '/public/siteImages/iOSTheme/wishlist/theme1/wishlist1.png';
import wishlist2 from '/public/siteImages/iOSTheme/wishlist/theme1/wishlist2.png';
import wishlist3 from '/public/siteImages/iOSTheme/wishlist/theme1/wishlist3.png';
import wishlist4 from '/public/siteImages/iOSTheme/wishlist/theme1/wishlist4.png';
import wishlist5 from '/public/siteImages/iOSTheme/wishlist/theme1/wishlist5.png';
import wishlist6 from '/public/siteImages/iOSTheme/wishlist/theme2/wishlist6.png';
import wishlist7 from '/public/siteImages/iOSTheme/wishlist/theme2/wishlist7.png';
import wishlist8 from '/public/siteImages/iOSTheme/wishlist/theme2/wishlist8.png';
import wishlist9 from '/public/siteImages/iOSTheme/wishlist/theme2/wishlist9.png';
import wishlist10 from '/public/siteImages/iOSTheme/wishlist/theme2/wishlist10.png';
import wishlist11 from '/public/siteImages/iOSTheme/wishlist/theme3/wishlist11.png';
import wishlist12 from '/public/siteImages/iOSTheme/wishlist/theme3/wishlist12.png';
import wishlist13 from '/public/siteImages/iOSTheme/wishlist/theme3/wishlist13.png';
import wishlist14 from '/public/siteImages/iOSTheme/wishlist/theme3/wishlist14.png';
import wishlist15 from '/public/siteImages/iOSTheme/wishlist/theme3/wishlist15.png';
import wishlist16 from '/public/siteImages/iOSTheme/wishlist/theme4/wishlist16.png';
import wishlist17 from '/public/siteImages/iOSTheme/wishlist/theme4/wishlist17.png';
import wishlist18 from '/public/siteImages/iOSTheme/wishlist/theme4/wishlist18.png';
import wishlist19 from '/public/siteImages/iOSTheme/wishlist/theme4/wishlist19.png';
import wishlist20 from '/public/siteImages/iOSTheme/wishlist/theme4/wishlist20.png';

export {
    wishlist1,
    wishlist2,
    wishlist3,
    wishlist4,
    wishlist5,
    wishlist6,
    wishlist7,
    wishlist8,
    wishlist9,
    wishlist10,
    wishlist11,
    wishlist12,
    wishlist13,
    wishlist14,
    wishlist15,
    wishlist16,
    wishlist17,
    wishlist18,
    wishlist19,
    wishlist20
}